import React from 'react';
import { touchWebClient } from 'tradera-utils/http';
import { useDispatch, useSelector } from 'react-redux';
import { selectAutomaticTranslationPreference } from 'tradera-state/language/selectors';
import styles from './translation-preference-menu-item.module.scss';
import { setAutomaticTranslationPreference } from 'tradera-state/language/reducer';
import { useTranslator } from 'tradera-lang/translate';
import { useIsFeatureEnabled } from 'tradera-hooks/use-is-feature-enabled';
import { selectIsLoggedIn } from 'tradera-state/member';

export const TranslationPreferenceMenuItem = () => {
    const { t } = useTranslator();
    const dispatch = useDispatch();
    const automaticTranslationPreference = useSelector(
        selectAutomaticTranslationPreference
    );
    const isLoggedIn = useSelector(selectIsLoggedIn);

    const isAutomaticTranslationPreferenceEnabled = useIsFeatureEnabled(
        'automatic-translation-preference'
    );

    const onAutomaticTranslationPreferenceChanged = async e => {
        const checked = e.target.checked;
        await touchWebClient.post(
            'my/profile/save-automatic-translation-preference-setting',
            { isAutomaticTranslationPreferenceEnabled: checked }
        );

        dispatch(
            setAutomaticTranslationPreference({
                automaticTranslationPreference: checked
            })
        );
    };
    return isLoggedIn && isAutomaticTranslationPreferenceEnabled ? (
        <div className="p-2">
            <label
                className={`form-toggle-label size-paris font-weight-bold d-flex align-items-center justify-content-between`}>
                {t('profileMenu_translationPreferenceHeading')}
                <input
                    type="checkbox"
                    className={`form-toggle-input ${styles.translationPreferenceFormToggleInput}`}
                    checked={automaticTranslationPreference}
                    onChange={onAutomaticTranslationPreferenceChanged}
                />
            </label>
            <div className="font-italic text-gray-600 size-oslo">
                {t('profileMenu_translationPreferenceText')}
            </div>
        </div>
    ) : null;
};
